class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.open = false;
  }

  connectedCallback() {
    this.button = this.querySelector('[data-toggle-button]');
    this.descriptionClamp = this.querySelector('[data-description-clamp]');
    this.readMoreText = this.querySelector('[data-read-more]').innerText;
    this.readLessText = this.querySelector('[data-read-less]').innerText;

    this.button.addEventListener('click', () => this.toggle());
    this.checkOverflow();
    this.update();
  }

  checkOverflow() {
    // Temporarily remove line-clamp to get full height
    this.descriptionClamp.classList.remove('line-clamp-3');
    const fullHeight = this.descriptionClamp.scrollHeight;

    // Add line-clamp back and get the actual rendered height
    this.descriptionClamp.classList.add('line-clamp-3');
    const clampedHeight = this.descriptionClamp.clientHeight;

    // Hide button if content doesn't overflow (with small tolerance for rounding)
    if (fullHeight <= clampedHeight + 2) {
      this.button.style.display = 'none';
    } else {
      this.button.style.display = 'block';
    }
  }

  toggle() {
    this.open = !this.open;
    this.update();
  }

  update() {
    this.descriptionClamp.classList.toggle('line-clamp-3', !this.open);
    this.button.innerText = this.open ? this.readLessText : this.readMoreText;
  }
}
if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}
